import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => (
  <footer className="psl-footer" id="contact">
    <div className="psl-footer__col psl-footer__brand">
      <div className="psl-footer__wordmark">Patinhas Sem Lar</div>
      <p>Uma associação pequena, perto do mar. Acolhemos com tempo e entregamos com calma.</p>
      <span className="psl-footer__sign">com carinho, PSL ✿</span>
    </div>
    <div className="psl-footer__col">
      <h4>Contacto</h4>
      <a href="mailto:geral@patinhassemlar.org">geral@patinhassemlar.org</a>
      <p>Fim de semana · 9h – 11h30</p>
      <Link to="/contactos">Página de contactos →</Link>
      <Link to="/onde-estamos">Onde estamos →</Link>
    </div>
    <div className="psl-footer__col">
      <h4>Seguir</h4>
      <a href="https://www.instagram.com/patinhassemlar/" target="_blank" rel="noreferrer">
        Instagram @patinhassemlar
      </a>
      <a href="https://www.facebook.com/patinhassemlar/?locale=pt_PT" target="_blank" rel="noreferrer">
        Facebook / patinhassemlar
      </a>
    </div>
    <div className="psl-footer__col">
      <h4>Agir</h4>
      <Link to="/ajudar">Donativos</Link>
      <Link to="/ajudar">Acolhimento temporário</Link>
      <Link to="/ajudar">Voluntariado</Link>
      <Link to="/adotar">Adotar</Link>
    </div>
    <div className="psl-footer__legal">
      <span>© 2026 Associação Patinhas Sem Lar</span>
    </div>
  </footer>
);

export default Footer;
